<script>
  import { hexToNormalizedRGBA } from "../../../shared/common";
  import { a, getSelectedShapes } from "../../../shared/globalState/a";
  import { sm, stored } from "../../stores/stores";
  import { clear, create } from "../../../services/database";

  // *** icons ***
  import SaveIcon from "../tomat/icons/SaveIcon.svelte";
  import TextIcon from "../tomat/icons/TextIcon.svelte";
  import LineIcon from "../tomat/icons/LineIcon.svelte";
  import RectangleIcon from "../tomat/icons/RectangleIcon.svelte";
  import CircleIcon from "../tomat/icons/CircleIcon.svelte";
  import SelectIcon from "../tomat/icons/SelectIcon.svelte";
  import DeleteIcon from "../tomat/icons/DeleteIcon.svelte";
  import MoveIcon from "../tomat/icons/MoveIcon.svelte";
  import CopyIcon from "../tomat/icons/CopyIcon.svelte";
  import RotateIcon from "../tomat/icons/RotateIcon.svelte";
  import MirrorIcon from "../tomat/icons/MirrorIcon.svelte";
  import ScaleIcon from "../tomat/icons/ScaleIcon.svelte";
  import BreakIcon from "../tomat/icons/BreakIcon.svelte";
  import SaveDxfIcon from "../tomat/icons/SaveDxfIcon.svelte";
  import StampIcon from "../tomat/icons/StampIcon.svelte";
  import SavePdfIcon from "../tomat/icons/SavePdfIcon.svelte";
  import KeyboardIcon from "./icons/KeyboardIcon.svelte";
  import MakeBlockIcon from "./icons/MakeBlockIcon.svelte";
  import SaveToBlockCollectionIcon from "./icons/SaveToBlockCollectionIcon.svelte";

  import KeySet from "./KeySet.svelte";

  import { textLinesCollection } from "../../../libs/canvas-text/src/shared/state";
  import { updateZoomLevel as updateZoomLevelText } from "../../../libs/canvas-text/src/handlers/mouse/wheel";

  import { setRealScale as calcNewZlc } from "../../../shared/common";

  import { createEventDispatcher, onDestroy } from "svelte";
  import { updateZoomLevel } from "../../../handlers/mouse/wheel";

  import { fromEvent } from "rxjs";
  import { s } from "../../../shared/globalState/settings";

  import { CommandList as cl } from "../../../models/CommandList";
  import ButtonTool from "./ButtonTool.svelte";
  import CpointsIcon from "./icons/CpointsIcon.svelte";
  import ColorPicker from "./ColorPicker.svelte";

  import "bootstrap/dist/css/bootstrap.min.css";
  import * as bootstrap from "bootstrap";
  import { MyEvents } from "../../../shared/types";
  import { onMount } from "svelte";
  import { emit, on } from "../../../services/events";


  let dispatch = createEventDispatcher();

  let selectedLineColor = "#3F47CC";

  // *** exports ***
  export let isStampVisible;

  $: dispatch(isStampVisible)

  export let curFontSize;
  export let currentRealScale;
  export let showKeyboard;

  // *** stores ***
  let thicknessList = $stored.thicknessList;
  let scaleList = $stored.scaleList;
  let setMode = $stored.setMode;
  let gm = $stored.getMode;

  // *** vars ***

  let cm;
  let tbc = "p-1 rounded bg-slate-100 hover:bg-slate-200 text-slate-600 font-bold mx-0.5";
  let tic = "h-5 w-5 text-slate-500";
  let checkboxClass = "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mx-1";

  let magnet1Checked = true;
  let magnet2Checked = true;
  let anglesnapChecked;

  // ********* keyboard events *********

  const keyDown$ = fromEvent(document, "keydown");
  const keyUp$ = fromEvent(document, "keyup");

  $: a.mag1 = magnet1Checked;
  $: a.mag2 = magnet2Checked;
  $: a.angle_snap = anglesnapChecked;

  function toggleMag1Mag2() {
    magnet1Checked = !magnet1Checked;
    magnet2Checked = !magnet2Checked;
  }
  function toggleMag1() {
    magnet1Checked = !magnet1Checked;
  }
  function toggleMag2() {
    magnet2Checked = !magnet2Checked;
  }
  function toggleAngleSnap() {
    anglesnapChecked = !anglesnapChecked;
  }

  keyDown$.subscribe((event) => {
    if (["F3", "F4", "F5"].includes(event.key)) {
      event.preventDefault();

      switch (event.key) {
        case "F3":
          toggleMag1Mag2();
          break;
        case "F4":
          if (magnet1Checked) toggleMag2();
          break;
        case "F5":
          toggleAngleSnap();
          break;
        default:
          break;
      }

      return;
    }

    if (["text", "textEdit"].includes(gm()) && event.key !== "Escape") {
      return;
    } else if (event.ctrlKey) {
      a.ctrl = true;
    }

    // --- сочетания клавиш с SHIFT
    if (event.shiftKey) {
      switch (true) {
        case event.key === "F":
          toggleMag1();

          break;

        default:
          break;
      }
    }

    // --- Handle key down events
    switch (event.key) {
      case "Shift":
        a.angle_snap = true;

        break;
    }
  });

  keyUp$.subscribe((event) => {
    // Handle key up events
    if (!event.shiftKey && !anglesnapChecked) {
      a.angle_snap = false;
    }
    if (!event.ctrlKey) {
      a.ctrl = false;
    }
  });

  // *** lifecycle ***
  a.realScale$.subscribe((v) => {
    currentRealScale = v;

    // *** dispatchEvent ***
    dispatch("real-scale-changed", currentRealScale);
  });

  cm = cl.cm;

  // ********* color *********
  $: a.line.color = hexToNormalizedRGBA(selectedLineColor);
  $: a.rectangle.color = hexToNormalizedRGBA(selectedLineColor);
  $: a.circle.color = hexToNormalizedRGBA(selectedLineColor);

  function handleColorChange(event) {
    selectedLineColor = event.detail.color;
  }

  function handleColorPickerMouseEnter() {
    setMode("none");
  }

  // ********* thickness *********
  let selectedLineThickness = { v: 2, label: "2 мм" };

  $: a.line.thickness = selectedLineThickness.v;
  $: a.rectangle.thickness = selectedLineThickness.v;
  $: a.circle.thickness = selectedLineThickness.v;


  // *** bootstrap tooltip ***
  function tooltip() {
    var tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map((el) => new bootstrap.Tooltip(el));
  }

  // *** functions ***
  function saveShapes() {
    clear();
    create(a.shapes);
    create(textLinesCollection);
    create(cm.cmSealed());
    localStorage.setItem("zlc", a.zlc);
  }

  function changeFontSize(event) {
    var fontSize = event.target.value;
    textLinesCollection
      .filter((t) => t.selected)
      .forEach((t) => {
        t.fontSize = fontSize;
      });
    b.curTextLine.fontSize = fontSize;
    functionCalled$.next({
      self: "setFont",
    });
  }

  let scaleListMember;
  $: {
    scaleListMember = scaleList.find((scale) => scale.id === "x");
    scaleListMember.v = currentRealScale;
    scaleListMember.label = `1:${currentRealScale?.toFixed(1)}`;
    scaleListMember.selected = true;

    scaleList = scaleList; // в Svelte reactive statement массивы автоматически не обновляются, поэтому их нужно обновлять таким вот образом
  }

  function changeRealScale(event) {
    var value = event.target.value;
    var curZoom = a.zlc;
    var newZoom = calcNewZlc(value);

    var zoomShapeTo = newZoom / curZoom;
    a.zlc = newZoom;

    updateZoomLevel(zoomShapeTo);
    updateZoomLevelText(zoomShapeTo);

    s.realScale = event.target.value;
    event.target.blur();

    // *** dispatchEvent ***
    dispatch("real-scale-changed", currentRealScale);
  }

  function changeLineThickness(event) {
    selectedLineThickness.v = event.target.value;

    getSelectedShapes().forEach((shape) => {
      if ("thickness" in shape) {
        shape.thickness = selectedLineThickness.v;
      }
    });

    event.target.blur();
  }
  function preventDefaultEsc(event) {
    if (event.key === "Escape") {
      event.target.blur();
    }
  }

  function handleMouseover(e) {
    a.blockUI = true;
  }
  function handleMouseout(e) {
    let elem = e.target;
    let inputs = elem.querySelectorAll("input");
    inputs.forEach((elem) => {
      elem.blur();
    });
    let buttons = elem.querySelectorAll("button");
    buttons.forEach((elem) => {
      elem.blur();
    });
    a.blockUI = false;
  }

  function handleSheetFormatChange(event) {
    s.format = event.target.value.toLowerCase();
    event.target.blur();
  }

  function updateCommands(updatedCm) {
    cm = updatedCm.detail;
  }

  function handleIsStampVisible(event){
    var checked = event.target.checked;
    console.group(`** handleIsStampVisible **`);
    console.groupEnd();
    dispatch('isStampVisible', checked);
  }

  onMount(()=>{

  })

</script>

<KeySet bind:show={showKeyboard} on:updateCommands={updateCommands}></KeySet>

<div id="tools" class="tools z-50 w-100" tabindex="-1" role="toolbar" on:focus on:blur on:mouseover={handleMouseover} on:mouseout={handleMouseout}>
  <div class="flex-row flex-wrap jcc">
    <ColorPicker bind:value={selectedLineColor} on:change={handleColorChange} on:colorPickerMouseEnter={handleColorPickerMouseEnter} />

    {#key cm}
      <ButtonTool id="save" command={cm.save} on:click={saveShapes}>
        <div slot="icon">
          <SaveIcon {tic}></SaveIcon>
        </div>
      </ButtonTool>
      <ButtonTool id="keyboard" command={cm.keyboard} on:click={() => (showKeyboard = true)}>
        <div slot="icon">
          <KeyboardIcon {tic}></KeyboardIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="text" command={cm.text} on:click={(event) => cm.text.run(event)}>
        <div slot="icon">
          <TextIcon {tic}></TextIcon>
        </div>
      </ButtonTool>
      <div class="flex-row align-center">
        <input type="text" name="font-size" id="font-size-field" class="w-50px" placeholder="60" on:input={changeFontSize} value={curFontSize} />
      </div>

      <ButtonTool id="line" command={cm.line} on:click={() => setMode(cm?.line.type)}>
        <div slot="icon">
          <LineIcon {tic}></LineIcon>
        </div>
      </ButtonTool>
      <div>
        <select title="Толщина линий" tabindex="-1" id="line-thickness" class={tbc} on:change={changeLineThickness} on:keydown={preventDefaultEsc}>
          {#each thicknessList as option}
            {#if option.v === 2}
              <option value={option.v} selected>{option.label}</option>
            {:else}
              <option value={option.v}>{option.label}</option>
            {/if}
          {/each}
        </select>
      </div>

      <ButtonTool id="rectangle" command={cm.rectangle} on:click={() => setMode(cm?.rectangle.type)}>
        <div slot="icon">
          <RectangleIcon {tic}></RectangleIcon>
        </div>
      </ButtonTool>
      <ButtonTool id="circle" command={cm.circle} on:click={() => setMode(cm?.circle.type)}>
        <div slot="icon">
          <CircleIcon {tic}></CircleIcon>
        </div>
      </ButtonTool>
      <ButtonTool id="select" command={cm.select} on:click={() => setMode(cm?.select.type)}>
        <div slot="icon">
          <SelectIcon {tic}></SelectIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="make-block" command={cm.makeBlock} on:click={cm.makeBlock.run()}>
        <div slot="icon">
          <MakeBlockIcon {tic}></MakeBlockIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="cpoints" command={cm.assignConnectionPoints} on:click={cm.assignConnectionPoints.run()}>
        <div slot="icon">
          <CpointsIcon {tic}></CpointsIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="save-to-block-collection" command={cm.saveToBlockCollection} on:click={cm.saveToBlockCollection.run()}>
        <div slot="icon">
          <SaveToBlockCollectionIcon {tic}></SaveToBlockCollectionIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="delete" command={cm.delete} on:click={cm?.delete.run()}>
        <div slot="icon">
          <DeleteIcon {tic}></DeleteIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="move" command={cm.move} on:click={() => setMode(cm?.move.type)}>
        <div slot="icon">
          <MoveIcon {tic}></MoveIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="copy" command={cm.copy} on:click={() => setMode(cm?.copy.type)}>
        <div slot="icon">
          <CopyIcon {tic}></CopyIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="rotate" command={cm.rotate} on:click={() => setMode(cm?.rotate.type)}>
        <div slot="icon">
          <RotateIcon {tic}></RotateIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="mirror" command={cm.mirror} on:click={() => setMode(cm?.mirror.type)}>
        <div slot="icon">
          <MirrorIcon {tic}></MirrorIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="scale" command={cm.scale} on:click={() => setMode(cm?.scale.type)}>
        <div slot="icon">
          <ScaleIcon {tic}></ScaleIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="break" command={cm.break} on:click={() => setMode(cm?.break.type)}>
        <div slot="icon">
          <BreakIcon {tic}></BreakIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="saveDxf" command={cm.dxf} on:click={(event) => cm.dxf.run(event)}>
        <div slot="icon">
          <SaveDxfIcon {tic}></SaveDxfIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="stamp" command={cm.stamp} on:click={(event) => cm?.stamp.run(event)}>
        <div slot="icon">
          <StampIcon {tic}></StampIcon>
        </div>
      </ButtonTool>

      <ButtonTool id="savePdf" command={cm.pdf} on:click={(event) => cm.pdf.run(event)}>
        <div slot="icon">
          <SavePdfIcon {tic}></SavePdfIcon>
        </div>
      </ButtonTool>

      <div class="flex-row align-center">
        <input type="checkbox" tabindex="-1" name="is-stamp-visible" id="is-stamp-visible" on:change={handleIsStampVisible} class={checkboxClass} />
        <label for="output">Рамка</label>
      </div>
      <div>
        <select tabindex="-1" name="" id="format" class={tbc} on:change={handleSheetFormatChange} on:keydown={preventDefaultEsc}>
          <option value="A4">A4</option>
          <option value="A3">A3</option>
          <option value="A2">A2</option>
          <option value="A1">A1</option>
        </select>
      </div>
      <div>
        {#key scaleList}
          <select title="Масштаб чертежа" tabindex="-1" id="real-scale-select" class={tbc} on:change={changeRealScale} on:keydown={preventDefaultEsc}>
            {#each scaleList as option}
              {#if option.selected}
                <option value={option.v} selected>{option.label}</option>
              {:else}
                <option value={option.v}>{option.label}</option>
              {/if}
            {/each}
          </select>
        {/key}
      </div>

      <div class="flex">
        <div class="flex-row align-center">
          <input type="checkbox" tabindex="-1" name="magnets" id="magnets" bind:checked={magnet1Checked} class={checkboxClass} />
          <label for="magnets">Маг1</label>
        </div>
        <div class="flex-row align-center">
          <input type="checkbox" tabindex="-1" name="magnets-trip" id="magnets-trip" bind:checked={magnet2Checked} class={checkboxClass} />
          <label for="magnets">Маг2</label>
        </div>
        <div class="flex items-center mx-1">
          <input type="checkbox" tabindex="-1" name="angleSnap" id="angleSnap" bind:checked={anglesnapChecked} class={checkboxClass} />
          <label for="angleSnap">Угл.</label>
        </div>
      </div>
      <div class="m-flex align-center m-justify-end m-mx-2 w-60">
        <div>
          <a class="link" href="/about.html" target="_blank">О программе</a>
        </div>
      </div>
    {/key}
  </div>
</div>

<style>
  .link {
    text-decoration: none;
    color: #3f47cc;
    font-weight: bold;
    border-bottom: 2px solid transparent; /* Set initial border to transparent with 0 width */
    display: inline-block;
    padding-bottom: 2px; /* Add padding to compensate for border width */
    transition: border-color 0.3s;
  }

  .link:hover {
    border-color: #3f47cc; /* Change border color on hover */
  }
</style>
